export const OPEN_NAV = 'TOGGLE_NAV'
export const CLOSE_NAV = 'CLOSE_NAV'
